import React from "react";

const PageHeader = ({
  title,
  subtitle,
  icon: Icon,
  actions,
  onViewModeChange,
  ViewModeIcon,
  viewModeText,
}) => {
  return (
    <div className="flex flex-col items-start justify-between rounded-lg bg-white p-6 shadow-sm sm:flex-row sm:items-center">
      <h1 className="mb-4 flex items-center text-3xl font-bold text-[#333333] sm:mb-0">
        <div className="mr-4 rounded-full bg-[#2ca01c] p-2 text-white">
          <Icon className="text-3xl" />
        </div>
        {title}
        {subtitle && (
          <span className="ml-2 text-sm font-normal text-gray-500">
            {subtitle}
          </span>
        )}
      </h1>

      <div className="flex w-full flex-col items-start space-y-3 sm:w-auto sm:flex-row sm:items-center sm:space-x-3 sm:space-y-0">
        {/* Toggle view mode button */}
        {onViewModeChange && (
          <button
            className="flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm transition-colors hover:bg-gray-50"
            onClick={onViewModeChange}
            title={viewModeText}
          >
            <ViewModeIcon className="mr-2 text-[#7028a9]" /> {viewModeText}
          </button>
        )}

        {/* Actions buttons */}
        {actions}
      </div>
    </div>
  );
};

export default PageHeader;
